import React from 'react';
import { ShieldCheck, Briefcase, UsersRound, Gavel, Handshake, Cog } from 'lucide-react';

const WhyChooseSection = () => {
  const features = [
    {
      icon: ShieldCheck,
      title: 'Compliant for US Founders',
      description: 'We specialize in helping US founders navigate the complexities of business incorporation, ensuring full compliance with all regulations.'
    },
    {
      icon: Briefcase,
      title: 'Comprehensive Services',
      description: 'From obtaining your Employer Identification Number (EIN) to opening a U.S. bank account, we handle all aspects of your business formation.'
    },
    {
      icon: UsersRound,
      title: 'Digital & Collaborative',
      description: 'Designed for seamless collaboration, ensuring you stay informed and engaged throughout the process.'
    },
    {
      icon: Gavel,
      title: 'No Lawyers Needed',
      description: 'Streamlined automated platform which can be used without the assistance of a US attorney. Trueledger provides process guidance.'
    },
    {
      icon: Handshake,
      title: 'Expert Partnership',
      description: 'Trueledger brings you a compliant route to incorporation. The platform brings you the trust and the expertise of K. Raghu & Co.'
    },
    {
      icon: Cog,
      title: 'Post-Incorporation Maintenance',
      description: 'Ongoing support to keep your business compliant with all necessary filings and documentation.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-gray-900">
          Built for Your Growth
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

const FeatureCard = ({ icon: Icon, title, description }) => {
  return (
    <div className="flex flex-col items-start p-6 rounded hover:bg-stone-50 transition-all duration-300 border border-transparent hover:border-stone-200 hover:shadow-md">
      <div className="w-12 h-12 bg-stone-100 rounded flex items-center justify-center mb-4">
        <Icon className="w-6 h-6 text-[#3E2723]" />
      </div>
      <h3 className="text-xl font-semibold mb-3 text-[#3E2723]">{title}</h3>
      <p className="text-gray-600 leading-relaxed">{description}</p>
    </div>
  );
};

export default WhyChooseSection;